module.exports = __webpack_public_path__ + "static/abduction-illustration-fda935adac8849914954b27c4b5795f2.svg";